import { Image as ImageIcon } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { MediaPreview } from "app/components/media-preview/MediaPreview";

import { AD_MODAL_CONTENT_HEIGHT } from "./constants";
import { StyledContainer } from "./styledComponents";

const errorContent = (
    <ImageIcon
        size="xl"
        color={colorsPalettes.carbon[200]}
    />
);

const emptyContent = (
    <ImageIcon
        size="xxl"
        color={colorsPalettes.carbon[200]}
    />
);

interface IAdPreviewSectionProps {
    imageUrl?: string | null;
    videoUrl?: string | null;
}

export const AdPreviewSection = ({ imageUrl, videoUrl }: IAdPreviewSectionProps) => {
    const isVideo = Boolean(videoUrl);

    if (!imageUrl && !videoUrl) {
        return (
            <Flex
                width="380px"
                height={AD_MODAL_CONTENT_HEIGHT}
                justifyContent="center"
                alignItems="center"
                style={{ backgroundColor: colorsPalettes.carbon[25], borderRadius: "6px", flexShrink: 0 }}
            >
                {emptyContent}
            </Flex>
        );
    }

    const sourceKey = `${imageUrl}-${videoUrl}`;

    return (
        <MediaPreview.Provider key={sourceKey}>
            <StyledContainer dataAutomation="ad-preview-section">
                <MediaPreview.Loader />
                <MediaPreview.Error>{errorContent}</MediaPreview.Error>
                {isVideo && videoUrl ? (
                    <MediaPreview.Video
                        src={videoUrl}
                        poster={imageUrl}
                        data-automation="ad-preview-video"
                    />
                ) : imageUrl ? (
                    <MediaPreview.Image
                        src={imageUrl}
                        data-automation="ad-preview-image"
                    />
                ) : null}
            </StyledContainer>
        </MediaPreview.Provider>
    );
};
